import { render, staticRenderFns } from "./DiscoveryCard.vue?vue&type=template&id=6f448e6e&scoped=true&"
import script from "./DiscoveryCard.vue?vue&type=script&lang=js&"
export * from "./DiscoveryCard.vue?vue&type=script&lang=js&"
import style0 from "./DiscoveryCard.vue?vue&type=style&index=0&id=6f448e6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f448e6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCard,VCardText,VIcon,VList,VListItem,VListItemContent})
